import {
  Component,
  OnInit,
  ViewChild,
  Input,
  TemplateRef,
  OnDestroy,
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { DocAccessListOutputModel } from '../shared/models/DocAccessListOutputModel';
import { environment } from '../../environments/environment';
import { IDocumentAccessOutputModel } from '../shared/models/DocumentAccessOutputModel';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { ToastService } from '../shared/providers/toast.service';
import { LoaderService } from '../shared/providers/loader.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DocAccessStatus } from '../shared/enum/enum';
import { IPropertyDetails } from '../shared/models/propertydetails';
import { DocAccessSearchCriteriaModel } from '../shared/models/DocAccessSearchCriteriaModel';
import { ValidationService } from '../shared/providers/validation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { Subscription } from 'rxjs';
import { DashboardTabs } from '../property/property-view.component';

@Component({
  selector: 'doc-access-listing',
  templateUrl: './doc-access-listing.component.html',
})
export class DocAccessListingComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  dtOptions = {};
  IsLoading = false;
  docAccess: DocAccessListOutputModel[];
  dashboardTabs = DashboardTabs;
  currentDocumentAccessRequest = {} as DocAccessListOutputModel;
  table: DataTableDirective;
  status = DocAccessStatus;
  docAccessSearchCriteriaModel = {} as DocAccessSearchCriteriaModel;
  @Input() property = {} as IPropertyDetails;
  @Input() AccessAdded: number = 0;
  @Input() IsFromProperty: number = 0;
  sourceType: string = '';
  docAccessOutput = {} as IDocumentAccessOutputModel;
  currentMenu = '';
  activeOMfilterButton = DocAccessStatus.New;
  activeDDfilterButton = DocAccessStatus.New;
  activeDownloadedfilterButton = 0;
  isFirstLoad: boolean = true;
  public propertyIds: number = 0;
  public propertyGuid: string;
  OMPending: number = 0;
  OMAccepted: number = 0;
  OMRejected: number = 0;
  DDNew: number = 0;
  DDPending: number = 0;
  Invited: number = 0;
  OmInvited: number = 0;
  DDAccepted: number = 0;
  DDRejected: number = 0;
  IsAccessPermitted: boolean = false;
  OMNew: number = 0;
  OMTotalCount: number = 0;
  DDTotalCount: number = 0;
  OMDownloaded: number = 0;
  DDDownloaded: number = 0;
  private Subscriptions: Subscription[] = [];
  filter: any;
  protected readonly BASE_URL: string = environment.base_url;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  hideFullPageContent = false;
  omapproval: any = false;
  caApproval: any = false;
  ddCaApproval: any = false;
  dueDiligenceApproval: any = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private propertyService: PropertyListingService,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private Validation: ValidationService,
    private modalService: BsModalService,
    private _propertyDetails: PropertyManagementService
  ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
    });
  }
  rowCount = 0;
  IsAdmin = false;
  user: any;

  ngOnInit() {
    if (
      this.property != null &&
      this.property != undefined &&
      this.property.Id != undefined &&
      this.property.Id > 0
    ) {
      this.checkOMApproval();
      this.checkCAApproval(1); // check OM CA
      this.checkCAApproval(2);// check DD CA
      this.checkddApproval();
    }
    this.propertyIds = this.property.Id;
    this.propertyGuid = this.property.Guid;

    if (this.Validation.IsinValid(this.property.Id)) {
      this.Validation.IfNoAccessThenRedirect(
        'DocumentAccess',
        'ViewRequestList'
      );
    } else {
      if (!this.Validation.hasAccess('DocumentAccess', 'ViewRequestList')) {
        this.hideFullPageContent = true;
      }
    }

    if (
      (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) &&
      this.IsFromProperty == 1
    ) {
      this.IsAdmin = true;
      this.IsAccessPermitted = true;
    }
    if (
      this.authService.IsUserRole(this.authService.UserRole.Broker) &&
      this.AccessAdded == 1 &&
      this.IsFromProperty == 1
    ) {
      this.IsAccessPermitted = true;
    }
    this.GetDocumentCount();
    this.defaultSearchCriteriaValues();
    this.user = this.authService.user;
    var userId = this.user.Id;
    const _instance = this;
    this.filter = {
      PropertyId: this.property.Id,
      Type: this.docAccessSearchCriteriaModel.Type,
      StatusId: this.docAccessSearchCriteriaModel.StatusId,
    };
    this.dtOptions = {
      // scrollY: '50vh',
      // scrollCollapse: true,
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      pageLength: 50,
      order: [[0, 'desc']],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: async (dataTablesParameters: any, callback: Function) => {
        dataTablesParameters.Extra_param = this.filter;
        this.IsLoading = true;
        //dataTablesParameters.Extra_param = this.docAccessSearchCriteriaModel;
        const httpHeader = this.Validation.GetAuthHeader();
        this.Subscriptions.push(
          _instance.http
            .post<DataTablesResponse>(
              (await this.BASE_URL) +
              '/property/documentaccessrequests/' +
              userId,
              dataTablesParameters,
              httpHeader
            )
            .subscribe((resp) => {
              _instance.docAccess = resp ? (resp.data ? resp.data : []) : [];

              if (this.rowCount == 0) {
                this.rowCount = resp.recordsTotal;
              }
              if (resp) {
                callback({
                  recordsTotal: resp.recordsTotal,
                  recordsFiltered: resp.recordsFiltered,
                  data: [],
                });
                if (resp.data.length === 0) {
                  $('.dataTables_paginate.paging_full_numbers').hide();
                } else {
                  $('.dataTables_paginate.paging_full_numbers').show();
                }
                $('.paginate_button.first,.paginate_button.last').hide();
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
                $('.dataTables_paginate.paging_full_numbers').hide();
              }
              this.IsLoading = false;
            })
        );
      },
      columns: [
        { data: 'DARId' },
        { data: 'DARId' },
        { data: 'PrincipalName' },
        { data: 'UserRole' },
        { data: 'PropertyName' },
        { data: 'OfferAccessRequestDate' },
        { data: 'RequestForOfferAccess' },
        { data: 'OfferDownloadedDate' },
        { data: 'DueDiligenceRequestDate' },
        { data: 'RequestForDueDiligenceAccess' },
        { data: 'DueDiligenceDownloadedDate' },
        { data: 'CADocumentPath' },
      ],
    };
  }

  async checkOMApproval() {
    this.Subscriptions.push(
      await this._propertyDetails
        .checkOMApproval(this.property.Id)
        .subscribe((responds) => {
          this.omapproval = responds;
        })
    );
  }

  async checkCAApproval(typeId) {
    this.Subscriptions.push(
      await this._propertyDetails
        .checkCAApproval(this.property.Id, typeId)
        .subscribe((responds) => {
          if (typeId == 1) {
            this.caApproval = responds;
          }
          else {
            this.ddCaApproval = responds;
          }
        })
    );
  }

  async checkddApproval() {
    this.Subscriptions.push(
      await this._propertyDetails
        .checkDDApproval(this.property.Id)
        .subscribe((responds) => {
          this.dueDiligenceApproval = responds;
        })
    );
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((sub) => sub.unsubscribe());
  }

  async GetDocumentCount() {
    this.user = this.authService.user;
    var userId = this.user.Id;
    if (this.property.Id == undefined) {
      this.property.Id = 0;
    }
    this.Subscriptions.push(
      await this.propertyService
        .GetDocumenAccessRequestListCount(this.property.Id, userId)
        .subscribe((response) => {
          if (response != null) {
            this.OMAccepted = response[0]?.OMAccepted ? response[0]?.OMAccepted : 0 ;
            this.OMRejected = response[0]?.OMRejected ? response[0]?.OMRejected :0;
            this.OMPending = response[0]?.OMPending ? response[0]?.OMPending :0;
            this.OMNew = response[0]?.OMNew ? response[0]?.OMNew :0;
            this.OMTotalCount =
              this.OMAccepted + this.OMRejected + this.OMPending + this.OMNew;
            this.DDAccepted = response[0]?.DDAccepted ? response[0]?.DDAccepted : 0;
            this.DDRejected = response[0]?.DDRejected ? response[0]?.DDRejected : 0;
            this.DDPending = response[0]?.DDPending ? response[0]?.DDPending : 0;
            this.Invited = response[0]?.Invited ? response[0]?.Invited : 0;
            this.OmInvited = response[0]?.OmInvited ? response[0]?.OmInvited : 0;
            this.DDNew = response[0]?.DDNew ? response[0]?.DDNew : 0;
            this.OMDownloaded = response[0]?.OMDownloaded ? response[0]?.OMDownloaded : 0;
            this.DDDownloaded = response[0]?.DDDownloaded ? response[0]?.DDDownloaded :0;
            this.DDTotalCount =
              this.DDAccepted + this.DDRejected + this.DDPending + this.DDNew;
          }
        })
    );
  }
  convertUTCDateToLocalDateOffer(OfferAccessRequestDate: Date) {
    var newDate = new Date(OfferAccessRequestDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - offset * 60 * 1000 * 60);
    return offsetTime;
  }
  convertUTCDateToLocalDateDue(DueDiligenceRequestDate: Date) {
    var newDate = new Date(DueDiligenceRequestDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - offset * 60 * 1000 * 60);
    return offsetTime;
  }

  defaultSearchCriteriaValues() {
    this.docAccessSearchCriteriaModel.Type = 0;
    this.docAccessSearchCriteriaModel.StatusId = 0;
    this.activeDDfilterButton = DocAccessStatus.New;
    this.activeOMfilterButton = DocAccessStatus.New;
    this.activeDownloadedfilterButton = 0;
  }

  filterByOMDownloaded() {
    this.defaultSearchCriteriaValues();
    this.activeDownloadedfilterButton = 1;
    this.filter = {
      PropertyId: this.property.Id,
      OMDownloaded: true,
    };
    this.dtElement.dtInstance.then((x) => x.draw());
  }

  filterByDDDownloaded() {
    this.defaultSearchCriteriaValues();
    this.activeDownloadedfilterButton = 2;
    this.filter = {
      PropertyId: this.property.Id,
      DDDownloaded: true,
    };
    this.dtElement.dtInstance.then((x) => x.draw());
  }

  filterByStatus(type, statusId) {
    if (type == 3) {
      this.isFirstLoad = true;
      this.defaultSearchCriteriaValues();
      this.docAccessSearchCriteriaModel.Type = type;
      this.docAccessSearchCriteriaModel.StatusId = statusId;
      this.filter = {
        PropertyId: this.property.Id,
        Type: this.docAccessSearchCriteriaModel.Type,
        StatusId: this.docAccessSearchCriteriaModel.StatusId,
      };
      this.dtElement.dtInstance.then((x) => x.draw());
    } else {
      this.isFirstLoad = false;
      this.docAccessSearchCriteriaModel.Type = type;
      if (type == 1) {
        this.activeOMfilterButton = statusId;
        this.activeDDfilterButton = DocAccessStatus.New;
      } else if (type == 2) {
        this.activeDDfilterButton = statusId;
        this.activeOMfilterButton = DocAccessStatus.New;
      }

      this.docAccessSearchCriteriaModel.Type = type;
      this.activeDownloadedfilterButton = 0;
      this.docAccessSearchCriteriaModel.StatusId = statusId;
      this.filter = {
        PropertyId: this.property.Id,
        Type: this.docAccessSearchCriteriaModel.Type,
        StatusId: this.docAccessSearchCriteriaModel.StatusId,
      };
      this.dtElement.dtInstance.then((x) => x.draw());
    }
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then((x) => x.search(text).draw());
  }

  onActionClick(
    type: string,
    status: DocAccessStatus,
    item: DocAccessListOutputModel
  ) {
    this.loaderService.display(true);

    if (type === 'OM') {
      this.docAccessOutput.PropertyId = item.PropertyId;
      this.docAccessOutput.RequestForOfferAccessId = status;
      this.docAccessOutput.UserId = item.UserId;
      this.docAccessOutput.IsCAAccepted = item.IsCAAccepted;
    } else {
      this.docAccessOutput.PropertyId = item.PropertyId;
      this.docAccessOutput.RequestForDueDiligenceAccessId = status;
      this.docAccessOutput.UserId = item.UserId;
      this.docAccessOutput.IsCAAccepted = item.IsCAAccepted;
    }

    this.docAccessOutput.IsPrincipal = false;
    this.user = this.authService.user;
    var userId = this.user.Id;
    this.docAccessOutput.LoggedinUserId = userId;
    this.propertyService
      .saveAccessRequestForDocuments(this.docAccessOutput)
      .subscribe((response) => {
        if (response != null) {
          this.toastService.addToast({
            title: 'Success',
            msg: 'Status updated successfully',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
          this.dtElement.dtInstance.then((x) => x.draw());
          this.docAccessOutput.RequestForOfferAccessId = null;
          this.docAccessOutput.RequestForDueDiligenceAccessId = null;
          this.GetDocumentCount();
        }
        this.loaderService.display(false);
      });
  }

  IsAgreementRequired: boolean = false;
  OpenAddUserSlider(
    template: TemplateRef<any>,
    classes: any,
    sourceType: string
  ) {
    this.IsAgreementRequired = (this.ddCaApproval != null && this.ddCaApproval || this.caApproval != null && this.caApproval) ? true : false;
    this.modalRef = this.modalService.show(template, { class: classes });
    this.sourceType = sourceType;
  }

  IsFromDetailsPage = true;
  OpenAddConfidentialityAgreement(
    template: TemplateRef<any>,
    classes: any,
    currentRequest: DocAccessListOutputModel
  ) {
    this.currentDocumentAccessRequest = currentRequest;
    this.IsAgreementRequired = (this.ddCaApproval != null && this.ddCaApproval || this.caApproval != null && this.caApproval) ? true : false;
    if (this.property != null && this.property.Id > 0) {
      this.IsFromDetailsPage = true;
    }
    else {
      this.IsFromDetailsPage = false;
    }
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  saveOMApproval(ddapproval) {
    this._propertyDetails
      .saveOMAPproval(this.property.Id, ddapproval)
      .subscribe((responds) => {
        if (responds) {
          this.toastService.addToast({
            title: 'Status Changed',
            msg: ddapproval
              ? 'Offering Memorandum Approval Added'
              : 'Offering Memorandum Approval Removed',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
          let currentRedirectUrl = this.setLink();
          this.router.navigateByUrl(currentRedirectUrl);
        } else {
          this.toastService.addToast({
            title: 'Offering Memorandum Approval Error',
            msg: 'Error Occured',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error',
          });
        }
      });
  }

  saveCAApproval(caApproval, typeId) {
    this._propertyDetails
      .saveCAAPproval(this.property.Id, caApproval, typeId)
      .subscribe((responds) => {
        if (responds) {
          this.toastService.addToast({
            title: 'Status Changed',
            msg: caApproval
              ? 'Confidentiality Agreement Approval Added'
              : 'Confidentiality Agreement Approval Removed',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
          let currentRedirectUrl = this.setLink();
          this.router.navigateByUrl(currentRedirectUrl);
        } else {
          this.toastService.addToast({
            title: 'Confidentiality Agreement Approval Error',
            msg: 'Error Occured',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error',
          });
        }
      });
  }

  saveDueDiligenceApproval(ddapproval) {
    this._propertyDetails
      .saveDueDiligenceApproval(this.property.Id, ddapproval)
      .subscribe((responds) => {
        if (responds) {
          this.toastService.addToast({
            title: 'Status Changed',
            msg: ddapproval
              ? 'Due Diligence Approval Added'
              : 'Due Diligence Approval Removed',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
          let currentRedirectUrl = this.setLink();
          this.router.navigateByUrl(currentRedirectUrl);
        } else {
          this.toastService.addToast({
            title: 'Due Diligence Approval Error',
            msg: 'Error Occured',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error',
          });
        }
      });
  }

  setLink() {
    localStorage.setItem('property-dashboard-Tab', this.dashboardTabs.DocAccess.toString());
    return this.router.url
  }

checkEditAccess(item: any) {
  if (item != null) {
    if (item.OfferMemoReqApproval || item.DueDiligenceReqApproval) {
      return true;
    }
    else if ((item.ConfidentialityAgreement || item.DDConfidentialityAgreement) && !item.OfferMemoReqApproval && !item.DueDiligenceReqApproval) {
      return true;
    }
    else {
      return false;
    }
  }
  else {
    return false;
  }

}
}
